import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import RelatedArticles from "../../Components/RelatedArticles";

const OralHealthAndHeart = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const page = t("oralHealthAndHeart.page", { returnObjects: true });
  const sections = page.sections;
  const faq = t("oralHealthAndHeart.page.faq", { returnObjects: true });

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/oral-health-and-heart"
        />

        <title>{t("oralHealthAndHeart.seo.title")}</title>
        <meta
          name="description"
          content={t("oralHealthAndHeart.seo.description")}
        />
        <meta name="keywords" content={t("oralHealthAndHeart.seo.keywords")} />
        <meta
          property="og:title"
          content={t("oralHealthAndHeart.seo.ogTitle")}
        />
        <meta
          property="og:description"
          content={t("oralHealthAndHeart.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Oral+Health+and+Heart"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={lang === "ar" ? "ar_AR" : "en_US"}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faq.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: { "@type": "Answer", text: item.answer },
            })),
          })}
        </script>
      </Helmet>

      <article
        className="container my-5 pt-5"
        dir={lang === "ar" ? "rtl" : "ltr"}
      >
        <h1 className="fw-bold text-center mb-4" style={{ color: "#00b3ff" }}>
          {page.title}
        </h1>
        <h5 className="text-center">{page.subtitle}</h5>
        <p className="text-center text-muted mb-5">{page.author}</p>

        <section>
          <p>{sections.introduction}</p>
        </section>

        <section>
          <h2>{sections.backgroundTitle}</h2>
          <ul>
            {sections.backgroundList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2>{sections.mechanismsTitle}</h2>
          <ol>
            {sections.mechanismsList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        </section>

        <section>
          <h2>{sections.clinicalEvidenceTitle}</h2>
          <ul>
            {sections.clinicalEvidenceList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2>{sections.treatmentTitle}</h2>
          <ul>
            {sections.treatmentList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2>{sections.discussionTitle}</h2>
          <p>{sections.discussionText}</p>
        </section>

        <section>
          <h2>{sections.conclusionTitle}</h2>
          <p>{sections.conclusionText}</p>
        </section>

        <section>
          <h2>{sections.referencesTitle}</h2>
          <ol className="text-start" dir="ltr">
            {sections.referencesList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        </section>

        <RelatedArticles />
      </article>
    </>
  );
};

export default OralHealthAndHeart;
